module.exports = __webpack_public_path__ + "img/GIFT_CARD_Virtual.01938c8.png";